import React from "react";
import { Outlet, Link, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { Signature, ethers } from "ethers";
import CypherPalacesArtifact from '../../web3/abi/CypherPalaces.json';
import { contractAddresses } from '../../web3/contractsAddresses';
import Background from "../background";
import styled from 'styled-components';
import PalaceTokenCard from "../PalaceTokenCard";
import fragmentsImg from '../gif/fragments.gif';
import SecretRooms from '../gif/secretRooms.gif';
import PortalImg from '../gif/secretRoomsaccess.gif';
import Board1 from '../img/board1.jpg';
import Board2 from '../img/board2.jpg';
import Board3 from '../img/board3.jpg';
import Board4 from '../img/board4.jpg';
import BoardHash from '../img/board_hash.jpg';
import BoardSeal from '../img/board_seal.jpg';
import BoardScreen from '../img/board_screen.jpg';
import BoardPB from '../img/board_pb.jpg';
import BoardSlot from '../img/board_slot.jpg';
import BoardSenior from '../img/board_senior.jpg';
import BoardTrick from '../img/board_trick.jpg';
import BoardAway from '../img/board_away.jpg';
import BoardSuit from '../img/board_suit.jpg';
import BoardDivert from '../img/board_divert.jpg';
import VideoPlayer from "../videoPlayer";

const utilities = require("../utilities");

function CypherPalaces() {


    const [tokens, setTokens] = useState([]);
    const [txError, setTxError] = useState(undefined);
    const [paginator, setPaginator] = useState(0);
    const previous = paginator - 1;
    const next = paginator + 1;

    // Shared singleton providers — no per-render provider creation (src/web3/providers.js)
    const { infuraProvider } = require("../../web3/providers");

    const cypherPalacesReadContract = new ethers.Contract(
        contractAddresses.CypherPalaces,
        CypherPalacesArtifact.abi,
        infuraProvider
    );

    useEffect(() => {
        getPalaces();
    }, [paginator]);

    const getPalaces = async () => {
        let fetchedTokens = [];
        try {
            setTokens([]);
            for (let i = paginator * 5; i < (paginator * 5 + 5); i++) {
                try {
                    let tokenURI = await cypherPalacesReadContract.tokenURI(i);
                    const tokenURIDecoded = utilities.parseBase64DataURI(tokenURI);
                    const tokenURIJSONDecoded = JSON.parse(tokenURIDecoded);
                    const tokenEntry = {
                        tokenId: i.toString(),
                        name: tokenURIJSONDecoded.name,
                        traits: tokenURIJSONDecoded.attributes,
                        image: tokenURIJSONDecoded.image
                    }
                    fetchedTokens.push(tokenEntry);
                    setTokens([...fetchedTokens]);
                } catch (error) {
                    console.log(error);
                }
            }
        } catch (error) {
            console.log(error);
            setTxError(error);
        }
    }

    function loadPrevious() {
        if (paginator < 1) {
            return ''
        } else {
            setPaginator(previous);
            return <button className="uxBtn">{`${(previous) * 5} to ${(paginator * 5) - 1}`}</button>
        }
    }

    function loadNext() {
        if (((next * 20) - 1) > 512) {
            return ''
        } else {
            setPaginator(next);
            return <button className="uxBtn">{`${(next * 5)} to ${Math.min((next * 5) + 19, 511)}`}</button>
        }

    }

    return (
        <div className="ProjectInfo">
            <p className="highlightInfo">CYPHERPALACES</p>
            <VideoPlayer src="https://felixfelixfelix.com/files/cypherpalace.mp4" autoPlay={true} loop={true} />
            <div className="descriptionDiv">
                <p className="starter">This project is based on an antique mnemonic technique nowadays known as mind palaces. There are very few sources about this antique knowledge. This 'artificial' memory was studied in depth by the historian Frances A. Yates in the book The art of Memory. it’s a concept that has been popping here and there without real continuity during 2000 years, always adapted to the contemporary ideology or mindset.</p>
                <p>This technique is simple : Using spatial memory to remember things.
                    One imagine and memorize a palace composed with a succession of distinctive rooms (colors shapes, patterns…). In each one is 'placed' a special object that serves as a mnemonic trigger. Then to remember the 'stored' informations, one simply has to 'walk' through the palace’s room and 'look' at mnemonic objects </p>
                <p>This concept is here transposed to the blockchain</p>
                <p>Computer memory became increasingly the extension of human memory.<br></br>
                    The world computer (Virtual machine on blockchains), with its immutable property, offers the promise of a permanence.</p>
                <p>However, on-chain data, even encrypted, remains exposed to the world.</p>
                <p>Human thoughts and memory remain the safest place to store, share, and produce information, and so it has been for millenniums before us.</p>
                <p>However, mind can be bent, twisted or eroded</p>
                <p>Blockchain space can be used to build enhanced, or augmented, memory palaces, gathering the best of the two worlds</p>
                <p>Cypherpalaces are the brain of their cypherdudes. Once inside this generative 3D environment, you can fly around the rooms, and interact with little blue fragments. On these you can inscribe the mnemonic symbols that will later trigger a specific memory.</p>
                <p>Additionnaly, each palaces comes with secret rooms. These are composed with 4 walls where its possible to draw. The drawings can then be stored on chain in order to be loaded later.</p>
                <p>Among the objects that are forming the digital architecture of the palace, the windows are a key element. At load they are showing broken links icons. It is possible to load all archives made by the cypherdudes inside the palace.<br></br> The cypherpalace turns into a gallery of the cypherdudes memory.</p>
            </div>
            <div className="ProjectInfo">
                <p>MAIN FEATURES</p>
                <div className="imgGrid">
                    <div className="imgThumb">
                        <img className="Img100" src={fragmentsImg} alt="Palace Fragment" />
                        <p className="captionText">There is one fragment per room. the symbols drawn can be stored on chain.</p>
                    </div>
                    <div className="imgThumb">
                        <img className="Img100" src={PortalImg} alt="Secret Room Portal" />
                        <p className="captionText">These portals are scattered inside the palace. on click, they lead you to the secret rooms.</p>
                    </div>
                    <div className="imgThumb">
                        <img className="Img100" src={SecretRooms} alt="Secret Room Grid" />
                        <p className="captionText">Inside a secret rooms, the whole walls can be used to draw. Data can be prepared off chain and imported in the room.</p>
                    </div>
                </div>
            </div>
            <div className="ProjectInfo">
                <p>COLLECTION</p>
                <div className="adminTools">
                    <div className="Paginators">
                        {paginator < 1 ?
                            '' :
                            <button onClick={loadPrevious} className="uxBtn">{`${(previous) * 5} to ${(paginator * 5) - 1}`}</button>
                        }
                        <p className="currentPagination">{`${(paginator) * 5} to ${Math.min((next * 5) - 1, 511)}`}</p>
                        {((next * 20) - 1) > 512 ?
                            '' :
                            <button onClick={loadNext} className="uxBtn">{`${(next * 5)} to ${Math.min((next * 5) + 4, 511)}`}</button>
                        }
                    </div>
                </div>
                <div className="collectionContainer">
                    {tokens.length < 1 ? `Fetching Cypherpalaces collection` : tokens.map((token, id) => {
                        return <PalaceTokenCard tokens={token} key={id} />
                    })}
                </div>
            </div>
        </div>
    )
}

export default CypherPalaces;